/**
 * @generated SignedSource<<4501c3275aed824d39d4e6f085066439>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type actionWidgetContent$data = {
  readonly __typename: string;
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleCommentsTriggerArticle" | "articlePrintArticle" | "copyLinkArticle20CopyLinkContent" | "entityLink">;
  readonly " $fragmentType": "actionWidgetContent";
};
export type actionWidgetContent$key = {
  readonly " $data"?: actionWidgetContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"actionWidgetContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "actionWidgetContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "articleCommentsTriggerArticle"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "articlePrintArticle"
        }
      ],
      "type": "Article",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "copyLinkArticle20CopyLinkContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "a62d3ac3f385af5799d6acfa146058f6";

export default node;
